import {useTranslation} from "react-i18next";

import Container from "../UI/Container";
import SectionHeader from "../UI/header/SectionHeader";
import ServiceBlock from "../UI/block/ServiceBlock";
import Ball from "../Ball";
import Hashtag from "../UI/other/Hashtag";

import './WhatWeDoSection.sass';
import WWDTopH from '../../assets/video/what-we-do-topH.mp4';
import WWDTopV from '../../assets/video/what-we-do-topV.mp4';
import WWDBottom1 from '../../assets/img/what-we-do-bottom1.jpg';
import WWDBottom2 from '../../assets/img/what-we-do-bottom2.jpg';
import service1 from '../../assets/video/service1.mp4';
import service2 from '../../assets/img/service2.jpg';
import service3 from '../../assets/img/service3.jpg';
import service4 from '../../assets/img/service4.jpg';
import service5 from '../../assets/img/service5.jpg';
import service6 from '../../assets/img/service6.jpg';

const WhatWeDoSection = (props) => {
    const { t } = useTranslation();

    return (
        <section className='what-we-do' id='whatWeDo' ref={props.sectionRef}>
            <Container className='p-relative'>
                <div className='what-we-do__header'>
                    <SectionHeader header={t("whatWeDo.header.title")}>
                        {t("whatWeDo.header.description")}
                    </SectionHeader>
                    <video autoPlay loop muted playsInline>
                        <source src={WWDTopV} type="video/mp4"/>
                    </video>
                    <video autoPlay loop muted playsInline>
                        <source src={WWDTopH} type="video/mp4"/>
                    </video>
                </div>

                <ServiceBlock
                    header={t("whatWeDo.services.service1.title")}
                    video={service1}
                    borderColor='#00FEEF'
                    description={t("whatWeDo.services.service1.description")}
                    className='mt-50'
                >
                    <Hashtag text={t("whatWeDo.services.service1.tag1")} />
                    <Hashtag text={t("whatWeDo.services.service1.tag2")} />
                    <Hashtag text={t("whatWeDo.services.service1.tag3")} />
                    <Hashtag text={t("whatWeDo.services.service1.tag4")} />
                </ServiceBlock>
                <ServiceBlock
                    header={t("whatWeDo.services.service2.title")}
                    image={service2}
                    imageRight
                    borderColor='#D3329E'
                    description={t("whatWeDo.services.service2.description")}
                    className='mb-50'
                >
                    <Hashtag text={t("whatWeDo.services.service2.tag1")} />
                    <Hashtag text={t("whatWeDo.services.service2.tag2")} />
                    <Hashtag text={t("whatWeDo.services.service2.tag3")} />
                    <Hashtag text={t("whatWeDo.services.service2.tag4")} />
                    <Hashtag text={t("whatWeDo.services.service2.tag5")} />
                    <Hashtag text={t("whatWeDo.services.service2.tag6")} />
                    <Hashtag text={t("whatWeDo.services.service2.tag7")} />
                </ServiceBlock>

                <div className='what-we-do__images'>
                    <img src={WWDBottom1} alt='' />
                    <img src={WWDBottom2} alt='' />
                </div>

                <ServiceBlock
                    header={t("whatWeDo.services.service5.title")}
                    image={service5}
                    borderColor='#75ED57'
                    description={t("whatWeDo.services.service5.description")}
                >
                    <Hashtag text={t("whatWeDo.services.service5.tag1")} />
                    <Hashtag text={t("whatWeDo.services.service5.tag2")} />
                    <Hashtag text={t("whatWeDo.services.service5.tag3")} />
                    <Hashtag text={t("whatWeDo.services.service5.tag4")} />
                    <Hashtag text={t("whatWeDo.services.service5.tag5")} />
                </ServiceBlock>

                <ServiceBlock
                    header={t("whatWeDo.services.service6.title")}
                    image={service6}
                    imageRight
                    borderColor='#75ED57'
                    description={t("whatWeDo.services.service6.description")}
                >
                    <Hashtag text={t("whatWeDo.services.service6.tag1")} />
                    <Hashtag text={t("whatWeDo.services.service6.tag2")} />
                    <Hashtag text={t("whatWeDo.services.service6.tag3")} />
                    <Hashtag text={t("whatWeDo.services.service6.tag4")} />
                    <Hashtag text={t("whatWeDo.services.service6.tag5")} />
                    <Hashtag text={t("whatWeDo.services.service6.tag6")} />
                </ServiceBlock>

                <ServiceBlock
                    header={t("whatWeDo.services.service3.title")}
                    image={service3}
                    borderColor='#75ED57'
                    description={t("whatWeDo.services.service3.description")}
                >
                    <Hashtag text={t("whatWeDo.services.service3.tag1")} />
                    <Hashtag text={t("whatWeDo.services.service3.tag2")} />
                    <Hashtag text={t("whatWeDo.services.service3.tag3")} />
                    <Hashtag text={t("whatWeDo.services.service3.tag4")} />
                    <Hashtag text={t("whatWeDo.services.service3.tag5")} />
                    <Hashtag text={t("whatWeDo.services.service3.tag6")} />
                    <Hashtag text={t("whatWeDo.services.service3.tag7")} />
                    <Hashtag text={t("whatWeDo.services.service3.tag8")} />
                    <Hashtag text={t("whatWeDo.services.service3.tag9")} />
                </ServiceBlock>
                <ServiceBlock
                    header={t("whatWeDo.services.service4.title")}
                    image={service4}
                    imageRight
                    borderColor='#D3C332'
                    description={t("whatWeDo.services.service4.description")}
                >
                    <Hashtag text={t("whatWeDo.services.service4.tag1")} />
                    <Hashtag text={t("whatWeDo.services.service4.tag2")} />
                    <Hashtag text={t("whatWeDo.services.service4.tag3")} />
                    <Hashtag text={t("whatWeDo.services.service4.tag4")} />
                    <Hashtag text={t("whatWeDo.services.service4.tag5")} />
                    <Hashtag text={t("whatWeDo.services.service4.tag6")} />
                    <Hashtag text={t("whatWeDo.services.service4.tag7")} />
                </ServiceBlock>
            </Container>

            <Ball
                top='10%'
                left='-10%'
                color='#37612D'
            />

            <Ball
                top='50%'
                left='-5%'
                color='rgba(32, 64, 231, 0.25)'
            />

            <Ball
                bottom='10%'
                right='-5%'
                color='#37612D'
            />
        </section>
    );
};

export default WhatWeDoSection;